import store from '../store'
import {getLocalToken, getLocalUser} from '../modules/auth/storage'
import {getGarage} from '../pages/home/storage'

export default async (to,from, next) => {
  document.title = `App Auto Peças Robertão`

  const token = getLocalToken()
  const user = getLocalUser()
  const id_user = localStorage.getItem('id_user')
  const garage = getGarage()
  //const credit = getCredito()
  //const credit_data = getDataAtualizacaoCredito()


  //com tratando rotas = null
  if (!token && to.name ==null) {
    next({name:'login'})
  }

  if (user && token && id_user && to.name == null) {

    next({name:'home'})

  }

  //com localstorage
  if (user && token && id_user && to.path != 'login' ) {

    store.dispatch('auth/ActionSetUserLocalStorage',user)
    store.dispatch('auth/ActionSetTokenLocalStorage',token)


    if (typeof garage !== 'undefined' && garage.length > 0) {
     
      store.dispatch('home/ActionSetGarageLocalStorage',garage)
      
    }

    next()
  }
  
  //com token
  if (token && user && to.name == 'login'){

      next({name:'home'})
  }
  //sem token
  if (!token && !user && to.path !== '/'|'/register'){
    if (to.name == 'register') {
      next()
    }
    else { 
      next({name:'login'})
    }
    
  }


  
  if (!token && to.name == 'home'){
    
    next({name:'login'})
  }


  else{
    next()
  }

}
